module.exports = __webpack_public_path__ + "566ba8c787b87015338e14db70482ed4.pdf";